import { partnerServices } from "../../config/axios"
import { GET_ACCOUNT_ID_LIST_FAILED, GET_ACCOUNT_ID_LIST_SUCCESS, LOADING_GET_ACCOUNT_ID_LIST, NETWORK_ERROR_GET_ACCOUNT_ID_LIST, RESET_GET_ACCOUNT_ID_LIST } from "../types"

export const resetGetAccountIdList = () => {
    return {
        type: RESET_GET_ACCOUNT_ID_LIST
    };
}

export const getAccountIdList = ( request, authToken ) => async (dispatch) => {
    dispatch({ type: LOADING_GET_ACCOUNT_ID_LIST })
    await partnerServices
    .post('getAccountIdList', request, { headers: { AuthToken: authToken } })
    .then( res => {
        switch( res.data.status ) {
            case 'success': 
                dispatch( { type: GET_ACCOUNT_ID_LIST_SUCCESS, payload: res.data } )
                break;
            default: 
                dispatch({ type: GET_ACCOUNT_ID_LIST_FAILED, payload: res.data })
                break;
        }
        console.log('Account Id List: ', res);
    } )
    .catch( err => {
        dispatch({ type: NETWORK_ERROR_GET_ACCOUNT_ID_LIST, payload: err });
    } )
}